module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadMoreBtn":"Read more"},"de":{"loadMoreBtn":"Weiterlesen"}}')
  delete Component.options._Ctor
}
